import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import ExtensionIcon from '@material-ui/icons/Extension';

export const rootRouteRef = createRouteRef();

const skillsPage = PageBlueprint.make({
  params: {
    path: '/skills',
    title: 'Skills',
    icon: <ExtensionIcon />,
    routeRef: rootRouteRef,
    loader: () => import('./SkillsPage').then(m => <m.SkillsPage />),
  },
});

export const skillsDashboardPlugin = createFrontendPlugin({
  pluginId: 'skills-dashboard',
  extensions: [skillsPage],
  routes: { root: rootRouteRef },
});
